import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import './WebflowPublishNotice.css';

/**
 * Webflow: shown right after Disconnect (POST /api/webflow/remove_webflow).
 * Our script came off the listed sites, but a removal reaches the live site
 * only when the site is published, and with the link ended the dashboard can
 * no longer publish for the customer: so the notice names the sites and says
 * to publish them in the Webflow Designer (Webflow guideline: prompt the user
 * to publish after any API-managed removal). It also says how to connect
 * again without a new authorization (toolkit 2026-10-27).
 */
export default function WebflowDisconnectedNotice({ sites = [] }) {
  const { t } = useTranslation();
  const names = sites.map((s) => s.name || s.id).filter(Boolean);
  return (
    <div className="wf-publish-notice" role="status" data-testid="wf-disconnected-notice">
      <FontAwesomeIcon icon={faCircleInfo} className="wf-publish-notice__icon" />
      <div className="wf-publish-notice__body">
        <strong>{t('wf_disconnected_title')}</strong>
        {names.length > 0 && <p>{t('wf_disconnected_sites', { sites: names.join(', ') })}</p>}
        <p className="wf-publish-notice__warn">{t('wf_disconnected_reconnect')}</p>
      </div>
    </div>
  );
}
